module.exports = __webpack_public_path__ + "static/media/research.67eebc08.md";